<template>
    <rkm-layout-body title="Lista de gestores">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({name: 'administracao-gestor-create'})"
                authorize="store-administracao-gestor"
                color="primary"
            >
                Cadastrar gestor
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/administracao/gestor/List'

export default {
    components: {List}
}
</script>